import { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext, setOnTokenInvalid } from '../context/AuthContext.jsx';

// 跳中枢登录（保留当前完整 URL 作为 redirect，登录完回跳）。
// local=1 时走本地登录表单（调试用），不跳中枢。
function redirectToAuthCenter() {
  const useLocalLogin = new URL(window.location.href).searchParams.get('local') === '1';
  if (useLocalLogin) return;
  sessionStorage.setItem('auth_redirect_from', window.location.href);
  window.location.href = 'https://auth.meijian.top';
}

export default function RequireAuth({ children, fallbackPath = '/report', onNavigate }) {
  const { token, loading, validating, hubUnreachable } = useContext(AuthContext);
  const [forceRedirect, setForceRedirect] = useState(false);
  const hasNavigatedRef = useRef(false);
  
  // 本地调试模式：直接放行
  const useLocalDebug = new URL(window.location.href).searchParams.get('local') === '1';
  if (useLocalDebug) return children;

  useEffect(() => {
    const fn = () => setForceRedirect(true);
    setOnTokenInvalid(fn);
    return () => setOnTokenInvalid(null);
  }, []);

  // 后端 401/403（cookie 里没有有效 token）→ 立即跳中枢
  useEffect(() => {
    if (forceRedirect && !hasNavigatedRef.current) {
      hasNavigatedRef.current = true;
      redirectToAuthCenter();
    }
  }, [forceRedirect]);

  // 启动时登录态探测完成：
  // - 有 token → 放行
  // - 无 token 且中枢可达（notLoggedIn）→ 跳中枢登录
  // - hubUnreachable（中枢 503）→ 不跳登录，显示"服务暂不可用"（用户可能已登录，只是中枢暂时不可达）
  useEffect(() => {
    if (token || loading || validating || hubUnreachable) return;
    const timer = setTimeout(() => {
      if (hasNavigatedRef.current) return;
      hasNavigatedRef.current = true;
      redirectToAuthCenter();
    }, 300);
    return () => clearTimeout(timer);
  }, [token, loading, validating, hubUnreachable]);

  if (loading || validating) {
    return <div className="loading">加载中...</div>;
  }

  if (hubUnreachable) {
    return (
      <div className="loading" style={{ textAlign: 'center', padding: '40px 16px' }}>
        <p style={{ fontSize: 15, color: '#666' }}>身份服务暂不可用，请稍后再试</p>
        <button
          style={{ marginTop: 12, padding: '8px 20px', border: '1px solid #ccc', borderRadius: 8, cursor: 'pointer' }}
          onClick={() => window.location.reload()}
        >
          重试
        </button>
      </div>
    );
  }

  if (!token) {
    return children;
  }

  return children;
}
